import { render, staticRenderFns } from "./Reportable.vue?vue&type=template&id=66ebf126&"
import script from "./Reportable.vue?vue&type=script&lang=js&"
export * from "./Reportable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports